<template>
  <div class="landing-widget">
    <iframe src="https://wp.meritios.com/" class="wp-mertios"></iframe>
    <cookieLaw v-if="show_cookie_law" @decline="cookieAccepted('declined')" @allow="cookieAccepted('allowed')">
    </cookieLaw>
  </div>
</template>
  
<script>
export default {
  name: "landing-page",
  components: {},
  metaInfo: {
    // Children can override the title.
    title: "Welcome to Meritios",
    titleTemplate: "%s",
    // Define meta tags here.
    meta: [{ name: "title", content: "Welcome to Meritios" }],
  },
  data() {
    return {};
  },
  mounted() {
    let vm = this;
    if (!vm.$localStorage.get("cookie:accepted")) {
      vm.show_cookie_law = true;
    }
    window.addEventListener(
      "message",
      (event) => {
        const message = event.data.message;
        switch (message) {
          case "navigateToPath":
            vm.$router.push({ path: event.data.value.path });
            break;
        }
      },
      false
    );
  },
  methods: {
    cookieAccepted(status) {
      let vm = this;
      vm.$localStorage.set("cookie:accepted", status);
      vm.show_cookie_law = false;
    },
  },
  watch: {},
};
</script>
  

<style lang="scss" scoped>
.landing-widget {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: #fff;

  .wp-mertios {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
  
  
  
  